import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

import routes from "./routes";
import { validateExpireAccessToken } from "../helpers/utils/jwt";
import store from "@/state/store";
import VueCookies from "vue-cookies";

Vue.use(VueRouter);
Vue.use(VueMeta, {
  keyName: "page",
});

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

router.beforeResolve((to, from, next) => {
  //console.log("to.name", to.name);
  if (to.name === "login" || to.name === "login-kc-callback") {
    next();
  } 
  else if (to.name === "logout") {
    let authProvider = store.getters["auth/getAuthProvider"];
    //console.log("index route auth provider", authProvider);
    clearAuthentication();
    if (authProvider === "keycloak") {
      redirecToLogoutKeyCloak();
    } else {
      redirecToLogin();
    }
  } else next();
});

// Before each route evaluates...
router.beforeEach(async (to, routeFrom, next) => {
  if (
    to.name === null &&
    !to.path.includes("login") &&
    !to.path.includes("portal")
  ) {
    next({ path: "/404" });
  } else {
    await checkAuthentication(to, next);
  }
});

var exceptList = [
  "Error-401",
  "Error-404",
  "Error-500",
  "Maintenance",
  "portal",
  "404",
  "logout",
  "login-kc-callback",
];

async function checkAuthentication(to, next) {
  // console.log('name', to.name)
  // console.log('!exceptList.includes(to.name)', !exceptList.includes(to.name))
  if (to.path !== "/login" && !exceptList.includes(to.name)) {
    localStorage.setItem("routeHistory", to.path);
  }

  if (
    to.path !== "/login" &&
    to.name !== "login-kc-callback" &&
    to.path !== "/register" &&
    to.name !== "Error-401" &&
    to.name !== "Maintenance"
  ) {
    if (!store.getters["auth/getIsAuthenticated"]) {
      clearAuthentication();
      redirecToLogin();
    } 
    else {
      if (await validateExpireAccessToken(store.getters["auth/getAccessToken"])) {
        next();
      } else {
        clearAuthentication();
        redirecToLogin();
      }
    }
  } 
  else {
    next();
  }
}

const redirecToLogin = () => {
  window.location = "/login";
};

const redirecToLogoutKeyCloak = () => {
  let redirect_url = encodeURIComponent(
    `${process.env.VUE_APP_BASE_URL}/login`
  );
  window.location.href = `${process.env.VUE_APP_BASE_URL_KEYCLOAK_LOGOUT}?post_logout_redirect_uri=${redirect_url}&client_id=${process.env.VUE_APP_KEYCLOAK_CLIENT_ID}`;
};

const clearAuthentication = () => {
  localStorage.removeItem(".authorize.data");
  // localStorage.removeItem("routeHistory")
  localStorage.removeItem("PIM");
  VueCookies.remove(".at");
  VueCookies.remove(".oauth.at");
  VueCookies.remove(".oauth.rt");
  VueCookies.remove(".oauth.usr");
  VueCookies.remove(".oauth.sk");
  store.dispatch("auth/removeAllAuthen");
};

export default router;
